import { SettingsSection } from '@components'

import { Button, Space, Text, useModal, withModalConditionalRender } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ExternalInvoicesSyncModal as ExternalInvoicesSyncModalComponent } from '@features/externalInvoicesSync'

import { ModalId } from '../../../../../../../../../../enums/modalId'
import { useSegment } from '../../../../../../../../../../hooks'

const ExternalInvoicesSyncModal = withModalConditionalRender(ExternalInvoicesSyncModalComponent)

const externalInvoicesSyncModalId = ModalId.ExternalInvoicesSyncModal

export const ImportSettings = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { open: openExternalInvoicesSyncModal } = useModal(externalInvoicesSyncModalId)

  const handleSyncButtonClick = useCallback(() => {
    openExternalInvoicesSyncModal()
    track('xxx-sales-HistoricalSync Invoicing Settings sync clicked')
  }, [openExternalInvoicesSyncModal, track])

  return (
    <SettingsSection.Content title={t('settings.organization.external_invoice.import.invoices_history.title')}>
      <Text colorVariant="secondary">
        {t('settings.organization.external_invoice.import.invoices_history.sync_your_documents')}
      </Text>
      <Space />
      <Button icon="refresh" onClick={handleSyncButtonClick} variant="outlined">
        {t('settings.organization.external_invoice.import.invoices_history.import_invoices')}
      </Button>
      <ExternalInvoicesSyncModal id={externalInvoicesSyncModalId} />
    </SettingsSection.Content>
  )
}
